import { HttpClient, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { getApp, getApps, initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { Config } from './lib/config/Config';
import { GlobalErrorHandler } from './lib/services/global-error-handler.service';

const firebaseApp = getApps().length > 0
  ? getApp()
  : initializeApp({
      projectId: 'salute-con-te',
      appId: '1:220709521591:web:77a3bc00d120ad9287a532',
      storageBucket: 'salute-con-te.firebasestorage.app',
      apiKey: 'AIzaSyAeSzKU930W9fdPiUfsvQEM-JSXy6QHb1w',
      authDomain: 'salute-con-te.firebaseapp.com',
      messagingSenderId: '220709521591',
      measurementId: 'G-DYVFXPWV3J',
    });

getAuth(firebaseApp);

function initializeApplication(httpClient: HttpClient): () => Promise<unknown> {
  return () => Config.getInstance().loadConfig(httpClient, environment);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    // I componenti standalone di NEXTComunica aprono date picker anche in modali:
    // l'adapter va quindi fornito a livello dell'app, non solo tramite un NgModule.
    provideMomentDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
    importProvidersFrom(
      AppRoutingModule,
      BrowserAnimationsModule,
      ServiceWorkerModule.register('ngsw-worker.js', {
        // In sviluppo il service worker entra in conflitto con il live reload di ng serve.
        enabled: environment.config.pwa.enabled,
        // solo registerWhenStable non permette la registrazione del sw, forse un bug di angular
        registrationStrategy: 'registerWhenStable:3000',
      }),
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApplication,
      deps: [HttpClient],
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
};
